<div nz-typography nzType="secondary" class="page-login__note">Для входа используйте ваше ФИО и пароль</div>

<form nz-form [formGroup]="form" class="login-form" (ngSubmit)="submitForm()">
  <nz-form-item>
    <nz-form-control nzErrorTip="Пожалуйста, введите ФИО!">
      <nz-input-wrapper>
        <nz-icon nzInputPrefix nzType="user" />
        <input
          type="text"
          nz-input
          formControlName="lecturerFullName"
          placeholder="Фамилия Имя Отчество"
          [nzAutocomplete]="autoUsers"
          autocomplete="off" />
      </nz-input-wrapper>

      <nz-autocomplete #autoUsers nzOverlayClassName="login-autocomplete">
        @for (u of recentLogins.usernamesForDropdown(); track u) {
          <nz-auto-option [nzValue]="u" (selectionChange)="onRecentLoginSelected($event)">{{ u }}</nz-auto-option>
        }
      </nz-autocomplete>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-control nzErrorTip="Пожалуйста, введите Ваш пароль!">
      <nz-input-wrapper>
        <nz-icon nzInputPrefix nzType="lock" />
        <input
          [type]="passwordVisible() ? 'text' : 'password'"
          nz-input
          formControlName="password"
          placeholder="Пароль" />
        <nz-icon
          class="cursor__pointer"
          nzInputSuffix
          [nzType]="passwordVisible() ? 'eye-invisible' : 'eye'"
          (click)="changePasswordVisible()"></nz-icon>
      </nz-input-wrapper>
    </nz-form-control>
  </nz-form-item>
  @if (error) {
    <nz-form-item>
      <nz-alert nzType="error" [nzMessage]="error"></nz-alert>
    </nz-form-item>
  }
  <div class="login-form__button">
    <button nz-button [nzType]="'primary'" [nzLoading]="isServiceInProgress">Войти</button>
  </div>
</form>
